import * as React from 'react';
import styled, { css } from 'styled-components';

import { IconSystemV2ButtonsMoreAlt } from '@doltech/icons/SystemV2/IconSystemV2ButtonsMoreAlt';
import { colorsV2 } from '../../colors-v2';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import cl from 'classnames';
import { LAYER } from '@doltech/utils/lib/constants';

const Container = styled.div<{ size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background-color: ${colorsV2.gray20};
  outline: 2px solid ${colorsV2.white100};
  z-index: ${LAYER.LAYER1};
  cursor: pointer;

  ${(p) => css`
    width: ${p.size}px;
    min-width: ${p.size}px;
    height: ${p.size}px;
  `}

  &:hover {
    background-color: ${colorsV2.gray40};
  }
`;

interface UserAvatarMoreProps {
  type?: 'more' | 'number-plus';
  size?: number;
  totalMore?: number;
  onClick?: () => void;
  className?: string;
}

export const UserAvatarMore = (props: UserAvatarMoreProps) => {
  const { className, type = 'more', size = 36, totalMore = 0, onClick, ...rest } = props;

  if (type === 'number-plus') {
    return (
      <Container
        className={cl('user-avatar-more number-plus', className)}
        size={size}
        onClick={onClick}
        {...rest}
      >
        <ResponsiveTypography.Paragraph variant={`medium/${size * 0.4}-20`} color="black100">
          {totalMore}+
        </ResponsiveTypography.Paragraph>
      </Container>
    );
  }

  return (
    <Container
      className={cl('user-avatar-more', className)}
      size={size}
      onClick={onClick}
      {...rest}
    >
      <IconSystemV2ButtonsMoreAlt size={(size * 3) / 5} color="black100" />
    </Container>
  );
};
